export default __webpack_public_path__ + "static/rsz_jarek_kaminski_photo_square-714aaaab12c0c01954da53958e0739f6.jpg";